module.exports = __webpack_public_path__ + "static/media/icon-generar.ef24c61c.svg";